/* camados-news.js — die Chronik auf camados.com/pages/news und die Zeitleiste
   auf der Roadmap.

   ── WARUM DIE FIRMWARE-EINTRÄGE NICHT IM QUELLTEXT STEHEN ──────────────────
   Sie stehen dort doch — aber nur als Rückfallebene. Die Seite holt die Liste
   beim Laden frisch aus der Cloud und ersetzt damit, was der Bauer eingebacken
   hat.

   Der Grund ist eine Lehre vom 16.09.2026: Auf der Box stand eine
   Update-Statusdatei zwei Fassungen zurück, weil niemand sie je neu geholt
   hatte. Die App las das und zeigte folgerichtig „kein Update". Ein alter Wert
   ist schädlicher als gar keiner — er sieht aus wie eine Antwort.

   Eine Nachrichtenseite, die bei jedem Release von Hand nachgetragen werden
   muss, ist derselbe Fehler mit Ansage. Also holt sie sich selbst, was neu ist.

   ⚠️ Die eingebackene Liste bleibt trotzdem: Ohne JavaScript, bei
   Netzproblemen oder wenn die Function einmal nicht antwortet, steht die Seite
   weiterhin — nur eben auf dem Stand des letzten Seitenbaus. Das ist der
   Unterschied zwischen „etwas älter" und „leer".

   ── DIE ANIMATION ──────────────────────────────────────────────────────────
   Die Punkte blenden beim Scrollen ein. Das ist Schmuck, deshalb gilt:
   Die Seite muss ohne ihn vollständig sein. Umgesetzt über eine Klasse, die
   der IntersectionObserver setzt — wer `prefers-reduced-motion` gesetzt hat
   oder kein JavaScript ausführt, bekommt alles sofort sichtbar. Niemals wird
   etwas per JavaScript versteckt, was ohne JavaScript sichtbar wäre. */

(function () {
  'use strict';

  /* ⚠️ ERST HIER wird das Verstecken ueberhaupt eingeschaltet.
     Das Stilblatt versteckt nur, was unter `.nw-js` steht. Solange diese Zeile
     nicht gelaufen ist, ist die Seite vollstaendig sichtbar — bei
     abgeschaltetem JavaScript, bei einem Ladefehler, bei einem Tippfehler in
     dieser Datei. Andersherum haetten wir eine Seite, die bei jedem
     Skriptproblem leer ist, und das faellt niemandem auf. */
  document.documentElement.classList.add('nw-js');

  var WOLKE = 'https://jbyjsanbwzmvesfqocfj.supabase.co';
  // Öffentlicher Lese-Schlüssel — derselbe, den auch die Box und die App
  // mitbringen. Er steht ohnehin im Quelltext jeder Seite; geheim ist an ihm
  // nichts, gated wird serverseitig.
  var ANON =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpieWpzYW5id3ptdmVzZnFvY2ZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMzgzNjgsImV4cCI6MjA5NjYxNDM2OH0.cXYYrMnAWfv-tEb7FZH5Y8g0BOJ-e4WyqiD2ahpvtb0';

  /* ── Einblenden beim Scrollen ──────────────────────────────────────────── */

  function einblendenVorbereiten(wurzel) {
    var punkte = (wurzel || document).querySelectorAll('.nw-blende:not(.nw-blende--fertig)');
    if (!punkte.length) return;

    // Wer weniger Bewegung will, bekommt weniger Bewegung. Nicht verhandelbar:
    // Bei manchen Menschen loest so etwas Uebelkeit aus.
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (ruhig || !('IntersectionObserver' in window)) {
      for (var i = 0; i < punkte.length; i++) punkte[i].classList.add('nw-blende--fertig');
      return;
    }

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        // Leichte Staffelung innerhalb eines Schwungs: Die Punkte kommen
        // nacheinander, nicht alle auf einmal. 60 ms reichen, damit man die
        // Reihenfolge sieht, ohne dass es sich nach Warten anfuehlt.
        var nr = Number(e.target.getAttribute('data-nr') || 0) % 6;
        e.target.style.transitionDelay = (nr * 60) + 'ms';
        e.target.classList.add('nw-blende--fertig');
        beobachter.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var j = 0; j < punkte.length; j++) {
      punkte[j].setAttribute('data-nr', String(j));
      beobachter.observe(punkte[j]);
    }
  }

  /* ── Die Chronik ───────────────────────────────────────────────────────── */

  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function datumLesbar(iso) {
    var t = String(iso || '').split('-');
    if (t.length !== 3) return String(iso || '');
    var m = parseInt(t[1], 10) - 1;
    return parseInt(t[2], 10) + '. ' + (MONATE[m] || t[1]) + ' ' + t[0];
  }

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }

  /* Der Kundentext eines Releases ist Klartext mit Zeilen, die mit "- "
     beginnen. Daraus eine Liste machen — aber NUR daraus. Alles andere bleibt
     Absatz. Kein Markdown-Leser, kein innerHTML: Der Text kommt zwar aus
     unserer eigenen Datenbank, aber er wird hier als TEXT gesetzt, nicht als
     HTML. Eine Seite, die fremden Text als Markup ausfuehrt, ist eine Seite,
     die man irgendwann bereut. */
  function textAufbauen(roh) {
    var raus = document.createDocumentFragment();
    var zeilen = String(roh || '').split('\n');
    var liste = null;
    zeilen.forEach(function (z) {
      var t = z.trim();
      if (!t) return;
      if (t.charAt(0) === '-') {
        if (!liste) { liste = el('ul', 'nw-punkte'); raus.appendChild(liste); }
        liste.appendChild(el('li', null, t.replace(/^-\s*/, '')));
      } else {
        liste = null;
        raus.appendChild(el('p', 'nw-absatz', t));
      }
    });
    return raus;
  }

  function eintragBauen(e) {
    var k = el('article', 'nw-eintrag nw-blende');
    var kopf = el('div', 'nw-eintrag__kopf');
    kopf.appendChild(el('span', 'nw-marke', 'Firmware ' + e.version));
    kopf.appendChild(el('time', 'nw-datum', datumLesbar(e.datum)));
    k.appendChild(kopf);
    var rumpf = el('div', 'nw-eintrag__text');
    rumpf.appendChild(textAufbauen(e.text));
    k.appendChild(rumpf);
    return k;
  }

  function chronikHolen() {
    var flaeche = document.querySelector('[data-news-chronik]');
    if (!flaeche) return;

    fetch(WOLKE + '/functions/v1/firmware-news', {
      method: 'POST',
      headers: {
        'apikey': ANON,
        'Authorization': 'Bearer ' + ANON,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ limit: 60 })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.eintraege || !d.eintraege.length) return;   // Rückfall bleibt stehen
        flaeche.innerHTML = '';
        d.eintraege.forEach(function (e) { flaeche.appendChild(eintragBauen(e)); });
        var hinweis = document.querySelector('[data-news-stand]');
        if (hinweis) hinweis.textContent = 'Stand: gerade eben, direkt aus der Cloud geladen.';
        einblendenVorbereiten(flaeche);
      })
      .catch(function () {
        /* Absichtlich still. Die eingebackene Liste steht schon auf der Seite;
           eine Fehlermeldung an ihrer Stelle waere ein Rueckschritt. */
      });
  }

  function los() {
    einblendenVorbereiten(document);
    chronikHolen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
